import axios from 'axios'
import Wrapper from '../../../components/Wrapper';
import React, { useEffect, useState } from 'react';
import Title from '../../../components/Title';

import Typography from '@mui/material/Typography';
import { NavLink, useParams } from 'react-router-dom';
import Box from '@mui/material/Box';
import Button from '@mui/material/Button';
import AddIcon from '@mui/icons-material/Add';
import useMediaQuery from '@mui/material/useMediaQuery';
import { useTheme } from '@mui/material/styles';
import Grid from '@mui/material/Grid'
import Card from '@mui/material/Card'
import CardContent from '@mui/material/CardContent'
import EditIcon from '@mui/icons-material/Edit';
import DeleteIcon from '@mui/icons-material/Delete';
import useAxiosInterceptor from '../../AxiosInterceptor';
import CalendarMonthIcon from '@mui/icons-material/CalendarMonth';
import { LendPay } from '../../../models/lendpay';
import { Modal, TextField } from '@mui/material';
import { DataGrid, GridColDef, GridToolbar } from '@mui/x-data-grid';
import MyModal from '../../../components/modales/modal_pagos';
import ModalAbonos from '../../../components/modales/modal_abono';
import PriceCheckIcon from '@mui/icons-material/PriceCheck';
import CloseIcon from '@mui/icons-material/Close';
import LocationOnIcon from '@mui/icons-material/LocationOn';
import "../../../index"; // Asegúrate de importar el archivo CSS donde definiste la clase
import { useNavigate } from 'react-router-dom';
import { formatOperationalDateOnly } from '../../../utils/operationalDateTime';
import Invoice from './modal/invoice';
import ReceiptIcon from '@mui/icons-material/Receipt';
import HeaderResponsive from '../../../components/layouts/HeaderResponsive';

interface ShowAlerts {
  showAlert: (message: string, severity?: 'success' | 'info' | 'warning' | 'error') => void;
  showLoading: () => void;
  hideLoading: () => void;
}

const AbonosPagos: React.FC<ShowAlerts> = ({ showAlert, showLoading, hideLoading }) => {

  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down('sm'));
  const { id } = useParams();
  const [lends, setLends] = useState([]);
  const [lendpay, setLendpay] = useState<LendPay[]>([]);

  const style = {
    width: isMobile ? '90%' : '60%', // Ajusta el ancho dependiendo si es mobile o no
    maxWidth: '450px', // Ancho máximo para pantallas grandes
    height: isMobile ? 'auto' : '75%', // Ajusta la altura automáticamente en mobile y usa un porcentaje fijo para pantallas más grandes
    maxHeight: '90vh', // Altura máxima para evitar que se salga de la pantalla
    overflowY: 'auto', // Añade scroll si el contenido excede la altura
    bgcolor: 'background.paper',
    boxShadow: 24,
    p: 2,
    borderRadius: 2,
    position: "absolute" as "absolute",
    top: "50%",
    left: "50%",
    transform: "translate(-50%, -50%)",
  };


  const [idnumber, setIdnumber] = useState('');
  const [fullname, setFullname] = useState('');
  const [cellphone, setCellphone] = useState('');
  const [mainaddress, setMainaddress] = useState('');
  const navigate = useNavigate();

  const [date, setDate] = useState('');
  const [value, setValue] = useState('');
  const [total_value, setTotal_value] = useState('');
  const [daily_pay_value, setDaily_pay_value] = useState('');
  const [days_term, setDays_term] = useState('');
  const [selectedPaymentId, setSelectedPaymentId] = useState<string | undefined>(undefined);
  const [modalInvoiceOpen, setModalInvoiceOpen] = useState(false); // Estado para controlar el modal de Invoice
  const [clientFullName, setClientFullName] = useState('');

  const handleOpenInvoiceModal = (fullName: string) => {
    setClientFullName(fullName);
    setModalInvoiceOpen(true);
  };

  const handleCloseInvoiceModal = () => {
    setModalInvoiceOpen(false);
  };

  useEffect(() => {
    const fetchData = async () => {
      try {
        const { data } = await axios.get(`lendpay/${id}`);
        setLendpay(data);
      } catch (error) {
        showAlert('Error al cargar los pagos', 'error');
        console.error(error);
      }
    };
    fetchData();
  }, [id]);


  useEffect(() => {
    (
      async () => {
        const { data } = await axios.get(`lends/${id}`);
        setLends(data)
        setIdnumber(data.client.idnumber);
        setFullname(data.client.fullname);
        setCellphone(data.client.cellphone);
        setMainaddress(data.client.mainaddress);
        setDate(data.date);
        setValue(data.value);
        setTotal_value(data.total_value);
        setDaily_pay_value(data.daily_pay_value);
        setDays_term(data.days_term);
      }
    )()
  }, []);

  const [modalOpen, setModalOpen] = useState(false);



  const handleCloseModal = () => {
    setModalOpen(false);
  };

  const [modalPagos, setModalPagos] = useState(false);


  const handleCloseModalPagos = () => {
    setModalPagos(false);
  };

  const handleOpenModal = (id: string | undefined) => {
    setSelectedPaymentId(id);
    setModalOpen(true);
  };

  const handleOpenModalPagos = (id: string | undefined) => {
    setSelectedPaymentId(id);
    setModalPagos(true);
  };

  const handleIconClick = () => {
    navigate(`/prestamos/abonos/pagos/invoice/${id}`);
  };

  const commonColumns: GridColDef[] = [
    { field: "pay_date", headerName: "Fecha Pago", flex: 1, },
    { field: "days_late", headerName: "Días Atraso", flex: 1 },
    { field: "value", headerName: "Valor Pagado", flex: 1 },
    { field: "discount", headerName: "Valor Descuento", flex: 1 },
    { field: "location", headerName: "Ubicación", flex: 1, renderCell: (params: { row: any }) => (params.row.location ? (<a href={`https://www.google.com/maps?q=${params.row.location}`} target="_blank" rel="noopener noreferrer" className="icon-link" > <LocationOnIcon /> </a>) : ("")), },
    {
      field: "state",
      headerName: "Estado",
      flex: 1,
      renderCell: (params) => (
        params.row.state === false ? <CloseIcon color="error" /> : <PriceCheckIcon color="success" onClick={() => handleOpenInvoiceModal(params.row.fullname)} />
      ),
    },
  ];
  const fullColumns: GridColDef[] = [
    { field: "pay_date", headerName: "Fecha Pago", flex: 1, },
    { field: "days_late", headerName: "Días Atraso", flex: 1 },
    { field: "value", headerName: "Valor Pagado", flex: 1 },
    { field: "discount", headerName: "Valor Descuento", flex: 1 },
    { field: "balance", headerName: "Valor Pendiente", flex: 1 },
    // { field: "location", headerName: "Ubicación", flex: 1, renderCell: (params: { row: any }) => (params.row.location ? (<a href={`https://www.google.com/maps?q=${params.row.location}`} target="_blank" rel="noopener noreferrer" className="icon-link" > <LocationOnIcon /> </a>) : ("")), },
    // {
    //   field: "state",
    //   headerName: "Estado2",
    //   flex: 1,
    //   renderCell: (params) => (
    //     params.row.state === false ? <CloseIcon color="error" /> : <ReceiptIcon color="success" onClick={() => handleOpenInvoiceModal(params.row.fullname)} />
    //   ),
    // },

    {
      field: "options",
      headerName: "Opciones",
      flex: 1,
      renderCell: (params: { row: any }) => (
        <div
          style={{
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
          }}
        >
          {params.row.location ? (
            <a
              href={`https://www.google.com/maps?q=${params.row.location}`}
              target="_blank"
              rel="noopener noreferrer"
              className="icon-link"
            >
              <LocationOnIcon />
            </a>
          ) : (
            ""
          )}
          {params.row.state === false ? (
            <CloseIcon color="error" />
          ) : (
            <NavLink
              to=""
              onClick={() => handleOpenInvoiceModal(params.row.fullname)}
              className="btn btn-sm btn-outline-secondary"
            >
              <ReceiptIcon color="primary" />
            </NavLink>
          )}

          <NavLink
            to=""
            onClick={() => handleOpenModal(params.row.id)}
            className="btn btn-sm btn-outline-secondary"
          >
            <EditIcon color="primary" />{" "}
          </NavLink>
          <MyModal
            isOpen={modalOpen}
            onClose={handleCloseModal}
            onButtonClick={() => {
              handleCloseModal();
            }}
            id={selectedPaymentId ?? ''} // Proporciona el id seleccionado
          />
          <NavLink to="" onClick={() => handleOpenModalPagos(params.row.id)} className="btn btn-sm btn-outline-secondary">
            <CalendarMonthIcon color="primary" />{" "}
          </NavLink>
          <ModalAbonos
            isOpenAbono={modalPagos}
            onCloseAbono={handleCloseModalPagos}
            onButtonClickAbono={() => {
              handleCloseModalPagos();
            }}
            id={selectedPaymentId ?? ''} // Proporciona el id seleccionado
          />
          <NavLink to="" className="btn btn-sm btn-outline-secondary">
            <DeleteIcon sx={{ color: "#d50000" }} />{" "}
          </NavLink>
        </div>
      ),
    },
  ];
  // Función para formatear la fecha
  const formatFecha = (dateString: any) => formatOperationalDateOnly(dateString);
  const columns = isMobile ? commonColumns : fullColumns;

  const rows = lendpay.map((lendpay: LendPay) => ({
    ...lendpay,
    id: lendpay.id,
    value: lendpay.value,
    discount: lendpay.value_discount,
    pay_date: formatFecha(lendpay.pay_date),
    days_late: lendpay.days_late,
    balance: lendpay.balance,
    order: lendpay.order,
    location: lendpay.location,
    interest: lendpay.interest,
    state: lendpay.state,
  }));

  return (
    <HeaderResponsive>
      <Box
        display="flex"
        justifyContent="space-between"
        alignItems="center"
        mb={2}
      >
        <Title>Detalle Pagos</Title>
        <Button
          variant="contained"
          startIcon={isMobile ? null : <AddIcon />}
          component={NavLink}
          to="/prestamos/abonos/add" // change "/your-path" to the path you want to navigate to
        >
          {isMobile ? <AddIcon /> : "Agregar"}
        </Button>
      </Box>
      <Card>
        <div style={{ height: "95%", width: "95%" }}>
          <CardContent>
             <Grid container spacing={2}>
              <Grid item xs={12} sm={6}>
                <TextField fullWidth type='number' label='Cédula Cliente' placeholder='143526799' id="idnumber" value={idnumber} onChange={event => setIdnumber(event.target.value)} inputProps={{ maxLength: 20 }} disabled />
              </Grid>
              <Grid item xs={12} sm={6}>
                <TextField fullWidth type='text' label='Nombre Cliente' placeholder='Ramon Perez' id="fullname" value={fullname} onChange={event => setFullname(event.target.value)} inputProps={{ maxLength: 30 }} disabled />
              </Grid>
              <Grid item xs={12} sm={6}>
                <TextField fullWidth type='number' label='Celular' placeholder='+51 982709009' id="cellphone" value={cellphone} onChange={event => setCellphone(event.target.value)} inputProps={{ maxLength: 10 }} disabled />
              </Grid>
              <Grid item xs={12} sm={6}>
                <TextField fullWidth type='text' label='Dirección' placeholder='' id="mainaddress" value={mainaddress} onChange={event => setMainaddress(event.target.value)} inputProps={{ maxLength: 30 }} disabled />
              </Grid>
              <Grid item xs={12} sm={6}>
                <TextField fullWidth type='date' label='Fecha Préstamo' placeholder='' id="date" value={date} onChange={event => setDate(event.target.value)} inputProps={{ maxLength: 10 }} disabled />
              </Grid>
              <Grid item xs={12} sm={6}>
                <TextField fullWidth type='number' label='Valor Préstamo' placeholder='' id="value" value={value} onChange={event => setValue(event.target.value)} inputProps={{ maxLength: 10 }} disabled />
              </Grid>
              <Grid item xs={12} sm={6}>
                <TextField fullWidth type='number' label='Total Préstamo' placeholder='' id="total_value" value={total_value} onChange={event => setTotal_value(event.target.value)} inputProps={{ maxLength: 10 }} disabled />
              </Grid>
              <Grid item xs={12} sm={6}>
                <TextField fullWidth type='number' label='Pago Diario' placeholder='' id="daily_pay_value" value={daily_pay_value} onChange={event => setDaily_pay_value(event.target.value)} inputProps={{ maxLength: 10 }} disabled />
              </Grid>
              <Grid item xs={12} sm={6}>
                <TextField fullWidth type='number' label='Plazo' placeholder='' id="days_term" value={days_term} onChange={event => setDays_term(event.target.value)} inputProps={{ maxLength: 3 }} disabled />
              </Grid>
            </Grid>
          </CardContent>

        </div>

        <Title>Plan de Pagos</Title>

        <div style={{ height: '100%', width: '100%', alignItems: 'center' }}>
          <DataGrid
            rows={rows}
            columns={columns}
            //  checkboxSelection
            density="compact"
            disableRowSelectionOnClick
            components={{
              Toolbar: () => (
                <div style={{ height: "95%", width: "95%" }}><GridToolbar /></div>
              ),
            }}
          />
        </div>
      </Card>
      <Modal
        open={modalInvoiceOpen}
        onClose={handleCloseInvoiceModal}
        aria-labelledby="invoice-modal-title"
        aria-describedby="invoice-modal-description"
        sx={{
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'center',
          zIndex: 1300
        }}
      >
        <Box sx={style}>
          <Invoice showAlert={showAlert} showLoading={showLoading} hideLoading={hideLoading} />
        </Box>
      </Modal>
    </HeaderResponsive >
  );
}

export default AbonosPagos
